
import { BaseMenuEntry, MenuEntryStatus } from '@/utilities/menu-entries/base-menu-entry';
import { defineComponent } from 'vue';
import { RouteRecordRaw, useRouter } from 'vue-router';

export default defineComponent({
    setup()
    {
        const router = useRouter();

        // Fetch all children routes of the route named "app"
        const allAppRoutes = router.getRoutes().find(item => (item.name === 'app'))?.children ?? [];

        function hasMetaEntry(route: RouteRecordRaw)
        {
            if (!route.meta?.entry) {
                return false;
            }

            return route.meta.entry instanceof BaseMenuEntry;
        }

        function getMetaEntry(route: RouteRecordRaw) : BaseMenuEntry
        {
            if (!hasMetaEntry(route)) {
                throw new Error("Trying to get metaEntry of a menu entry that doesn't have one");
            }

            return route.meta?.entry as BaseMenuEntry;
        }

        function isDisabled(route: RouteRecordRaw)
        {
            return hasMetaEntry(route) && !getMetaEntry(route).isEnabled();
        }

        function hasStatus(route: RouteRecordRaw)
        {
            return hasMetaEntry(route) && getMetaEntry(route).getStatus() !== MenuEntryStatus.NONE;
        }

        function hasPicto(route: RouteRecordRaw)
        {
            return hasMetaEntry(route);
        }

        function getAllStatus()
        {
            return MenuEntryStatus;
        }

        return {
            allAppRoutes,
            hasMetaEntry,
            getMetaEntry,
            isDisabled,
            hasStatus,
            hasPicto,
            getAllStatus,
        };
    },
})
